import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { EPSDataProvider } from '../dataProvider/EPSDataProvider';
import { API_TYPE_EPS, API_TYPE_MDM, API_TYPE_SVE } from '../../webcomponents.constants';
import { SVEDataProvider } from '../dataProvider/SVEDataProvider';
import { MDMDataProvider } from '../dataProvider/MDMDataProvider';

export class TargetsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_EPS, EPSDataProvider);
    this.map.set(API_TYPE_SVE, SVEDataProvider);
    this.map.set(API_TYPE_MDM, MDMDataProvider);
  }
}
